import { render } from "./agentPayments.vue?vue&type=template&id=5fd3f736"
import script from "./agentPayments.vue?vue&type=script&lang=js"
export * from "./agentPayments.vue?vue&type=script&lang=js"

import "./agentPayments.vue?vue&type=style&index=0&id=5fd3f736&lang=css"
import "./agentPayments.vue?vue&type=style&index=1&id=5fd3f736&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__